var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarFemale({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    fill: "url(#pattern0_51_3919)",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_51_3919",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_51_3919",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_51_3919",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEiElEQVR4nO2cTWhcVRTHjyKitrpScWHVhS78QiRVpAil6jJUF753/ufNaLWguLC4UEShEhXEj1Wr+AUu/AJBETcBcSNWUamo1VrqV5s55zU1rd/VQLXRjNwwYNNkkskkk/vunfuDP8wmM29+nJy57757L1EikUgkEolEIpFIJLpnaKh5vEh5A1jfEtiYQCcF9rt7Deg2sD4HlCKy//RFfEx/U8/K88H2kcCa8wVsR4TtjVreuMr3dQcFoNeA7ddOJE+PTgL6WqrwWSiKkXOF9U5AXwLsY4HtFthfC5c8TfioSHnlbJ/XdwCNy4VtuNV3FyG1rew/i7yxjvqX5nGAPSTQid4Inta7DxVFeSn15SiC7ZVeCz6msr+t18dWUD8B2BPLK7kVtq3ULxS5Xde7fjxvVU/keXkJ9UPLANsOP5Jb/Rr2KsWO5HazT8lTotmOMI+uopgB7Bvfolu9+nGKlTwvr/Au+H/RB1wboxgBdIt3wUeFWddQjAjMfMuNvn0wN87zLnZmdlNsMOtNFRB7THQyy344g2JCWJ/1L3ZmCtZBigmwfuBb6mwB9BGKCYH+6Ftqm/bxDsWCe8oh3oW2FV1SLAC2usKiJ7Ps4EqKAfeDI96Ftk9R2ADFAKC3+ZY5VwDLKQaE9YFqi9Z7KQYAfabSolmfphgA7E3fMucM2zDFgMA+rLZo/ZJiANDvvcucM/oLxQDYfvMvc+4MDu4/hUJm7drmCf6eeFvnkX0XUMjU63vO9C4R8yf4JWO1TC/yLVE6iJsvp5ARsat9S5QOAtj9FDKA3hiI6BcoZJj1njBE6zYKGcCe8i1ROssYhQxY36uAxGYnybK951DACxoP+RYonSYvQSFSqSVg6CCsL1KIBNSfmy5gHa/VvjuNQqJW23d2UG0DLdnQIQoJwO4IYo4DM6r65+D2JjLrtdWfIrWjou+7XboUIhs2NE5yNy1g/cm/yLaxgu0Wtx2PQmfj+q9PBXRTazdsRdqE7SjYbnfFQDHCrGsAe0xYd3loD18B+mjfbVtmHl0F2HpANwP2Oli3T+1zYTsAtsNdVOlh97du8yagn0y9J3RzwXZ99BuEFoMsrFonfV9vsEgSnURHQ5E31i20R7uxu+/rDop6fWwFWHd2M2QLfunAcpFl5cnC+nbXQzi24WjHxksFYBd3U8mz5AvmxoW+v0/lyLLGWW5adeqUr6W783Mnhm117039TlHYAGDPd3NzsoD87W5c3Dkh1E9k2cGVQGOju3Prodw2Va7bJS9vjfrIn6KwAfev3N05dkssHPaHwF6OpsqzbNeJU4ehsH3uW+4c+cwtCXPXSiE+AS/YMrDtrYDIZmfR0k2buhWwFAJ5PnIZ2D71L866ayusO93eSKoyQOPu5TgwUHpf3RPCdhdVEWF70r8gW9rqhm6hKiFs9/mWIj2Ke+ZJVcCd1QzWf30LkZ5F/3GrrqowP/GufxkW97Le4NbXIdDN+YA97FuALFfYHvQnuqJH+Ehs7QOwEd8CZNmie/yJZh3vm4pmHfcmOpFIJBKJRCKRSCSoh/wHQyghIKKAMNkAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarFemale);
export default __webpack_public_path__ + "static/media/avatar_female.59da6983caa9dbb07495603806c7d636.svg";
export { ForwardRef as ReactComponent };